import { iconProps } from './icons-types';

export const iconFeedback = ({ stroke }: iconProps) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 1.5H2.25C1.42125 1.5 0.75 2.17125 0.75 3V11.25C0.75 12.0788 1.42125 12.75 2.25 12.75H5.25L9 16.5L12.75 12.75H15.75C16.5788 12.75 17.25 12.0788 17.25 11.25V3C17.25 2.17125 16.5788 1.5 15.75 1.5Z"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.25 6H12.75" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
      <path d="M5.25 9H9.75" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
